// extracted by mini-css-extract-plugin
export default {"phoneNumber":"Iml7X"};